const SYSTEM_FIELD_LABELS = {
  nombres: {
    es: 'Nombres',
    en: 'First name(s)',
    aliases: ['nombre', 'nombres', 'first name', 'first names', 'given name', 'given names'],
  },
  apellidos: {
    es: 'Apellidos',
    en: 'Last name(s)',
    aliases: ['apellido', 'apellidos', 'last name', 'last names', 'surname', 'surnames', 'family name'],
  },
  numero_de_documento: {
    es: 'Número de documento',
    en: 'Document number',
    aliases: ['documento', 'numero documento', 'número documento', 'document number', 'id number', 'identification number'],
  },
  correo_electronico: {
    es: 'Correo electrónico',
    en: 'Email address',
    aliases: ['correo', 'correo electronico', 'email', 'e mail', 'email address'],
  },
  tipo_de_documento: {
    es: 'Tipo de documento',
    en: 'Document type',
    aliases: ['tipo documento', 'document type', 'id type', 'identification type'],
  },
  telefono: {
    es: 'Teléfono',
    en: 'Phone number',
    aliases: ['telefono', 'teléfono', 'phone', 'phone number', 'mobile', 'mobile phone'],
  },
  ciudad: {
    es: 'Ciudad',
    en: 'City',
    aliases: ['ciudad', 'city'],
  },
  pais: {
    es: 'País',
    en: 'Country',
    aliases: ['pais', 'país', 'country'],
  },
  departamento: {
    es: 'Departamento',
    en: 'State / Department',
    aliases: ['departamento', 'department', 'state', 'state department', 'province', 'region'],
  },
  categoria: {
    es: 'Categoría',
    en: 'Category',
    aliases: ['categoria', 'categoría', 'category'],
  },
  empresa: {
    es: 'Empresa',
    en: 'Company',
    aliases: ['empresa', 'company', 'organization', 'organisation'],
  },
  profesion: {
    es: 'Profesión',
    en: 'Profession',
    aliases: ['profesion', 'profesión', 'profession', 'occupation'],
  },
  especialidad: {
    es: 'Especialidad',
    en: 'Specialty',
    aliases: ['especialidad', 'specialty', 'speciality'],
  },
  direccion: {
    es: 'Dirección',
    en: 'Address',
    aliases: ['direccion', 'dirección', 'address'],
  },
  indicativo_de_telefono: {
    es: 'Indicativo de teléfono',
    en: 'Country calling code',
    aliases: ['indicativo telefono', 'indicativo de telefono', 'codigo pais', 'código país', 'country calling code', 'country code', 'dialing code'],
  },
  staff_id: {
    es: 'ID',
    en: 'ID',
    aliases: ['id', 'staff id', 'staff_id'],
  },
};

export const normalizeFieldLanguage = (language) => language === 'en' ? 'en' : 'es';

export const humanizeEventFieldLabel = (value) => String(value || '')
  .replace(/[_-]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .replace(/^./, (character) => character.toUpperCase());

export const getEventFieldLabel = (field, language = 'es') => {
  const normalizedLanguage = normalizeFieldLanguage(language);
  const label = String(field?.label || field?.name_campo || '').trim();
  const configuredEs = String(field?.nombre_del_campo || '').trim();
  const configuredEn = String(field?.nombre_del_campo_en || '').trim();
  const system = SYSTEM_FIELD_LABELS[label];

  if (normalizedLanguage === 'en') {
    return configuredEn || system?.en || configuredEs || humanizeEventFieldLabel(label);
  }

  return configuredEs || system?.es || humanizeEventFieldLabel(label);
};

export const getEventFieldHeaderAliases = (field) => {
  const label = String(field?.label || field?.name_campo || '').trim();
  const system = SYSTEM_FIELD_LABELS[label];
  const aliases = [
    label,
    humanizeEventFieldLabel(label),
    field?.nombre_del_campo,
    field?.nombre_del_campo_en,
    system?.es,
    system?.en,
    ...(system?.aliases || []),
  ];

  return Array.from(new Set(aliases.map((value) => String(value || '').trim()).filter(Boolean)));
};

export const getSystemEventFieldLabel = (label, language = 'es') => (
  getEventFieldLabel({ label }, language)
);

export { SYSTEM_FIELD_LABELS };
